var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0548 19.0013C21.2456 15.9452 21.3014 12.8822 21.2219 9.8212C21.2078 9.20037 21.0039 8.59875 20.6377 8.09724C19.2369 6.19022 18.1226 5.0043 16.284 3.58598C15.7775 3.1978 15.1599 2.98192 14.5219 2.96994C13.8481 2.95566 13.1742 2.94876 12.5002 2.94924C10.3401 2.94924 8.59705 3.01292 6.79509 3.13867C6.05391 3.18856 5.35617 3.50627 4.83192 4.03256C4.30767 4.55886 3.9927 5.25784 3.9457 5.9992C3.81105 8.1636 3.74416 10.3317 3.74513 12.5003C3.74513 14.7288 3.81358 16.9033 3.9457 19.0013C4.04121 20.5359 5.26056 21.7568 6.79509 21.8619C8.59705 21.9876 10.3401 22.0513 12.5002 22.0513C14.6604 22.0513 16.4034 21.9876 18.2054 21.8619C18.9465 21.812 19.6443 21.4943 20.1685 20.968C20.6928 20.4417 21.0078 19.7427 21.0548 19.0013Z",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25488 9.62384L8.71937 10.9849C9.40705 9.202 9.9817 8.41722 11.2806 7.35547",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25488 16.0512L8.71937 17.4106C9.40705 15.6278 9.9817 14.843 11.2806 13.7812",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8008 9.93359H17.7804",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8008 16.7031H17.7804",
    stroke: "#D0CDD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/formIcon.0c9569fb5490359d463955c059c33241.svg";
export { ForwardRef as ReactComponent };